const verbiageContent = {

    "errorScenarios": [
        {
            "error_msg": [
                {
                    "message": {
                        "buttonText": "Exit",
                        "footerMsg": "",
                        "subHeaderMsg2": "You can apply again after {repDate}",
                        "subHeaderMsg1": "Currently we are unable to process your request as we have issued an SBI Credit Card to you within last 90 days",
                        "headerMsg": "Dear {name},<br />thank you for your request",
                        "middleMsg": ""
                    },
                    "statusCode": "90Days"
                },
                {
                    "message": {
                        "buttonText": "Exit",
                        "footerMsg": "",
                        "subHeaderMsg2": "Request you to apply again after 30 days",
                        "subHeaderMsg1": "Currently we are unable to process your card application for {cardname} due to our internal policies",
                        "headerMsg": "Dear {name},<br />thank you for your request",
                        "middleMsg": ""
                    },
                    "statusCode": "30DayDecline"
                },
                {
                    "message": {
                        "buttonText": "Provide information",
                        "footerMsg": "",
                        "subHeaderMsg2": "We request you to provide additional information to process your application",
                        "subHeaderMsg1": "Your application number is {applicationnumber}",
                        "headerMsg": "Dear {name},<br />your application is already in progress.",
                        "middleMsg": ""
                    },
                    "statusCode": "WIP-DC"
                },
                {
                    "message": {
                        "buttonText": "Exit",
                        "footerMsg": "",
                        "subHeaderMsg2": "We request you to provide additional information to process your application",
                        "subHeaderMsg1": "Your application number is {applicationnumber}",
                        "headerMsg": "Dear {name},<br />your application is already in progress.",
                        "middleMsg": ""
                    },
                    "statusCode": "WIP"
                }
            ],
            "errorItem": "Pan Dedupe"
        },
        {
            "error_msg": [
                {
                    "message": {
                        "buttonText": "Exit",
                        "footerMsg": "",
                        "subHeaderMsg2": "We regret to inform you that we are unable to process your card application currently due to internal policies.",
                        "subHeaderMsg1": "Your application number is {applicationnumber}",
                        "headerMsg": "Dear {name},<br /> thank you for your request",
                        "middleMsg": ""
                    },
                    "statusCode": "JourneyEndALL"
                },
                {
                    "message": {
                        "buttonText": "Exit",
                        "footerMsg": "",
                        "subHeaderMsg2": "We regret to inform you that we are unable to process your card application currently due to internal policies.",
                        "subHeaderMsg1": "currently we are unable to process your request",
                        "headerMsg": "Dear {name},<br /> thank you for your request",
                        "middleMsg": ""
                    },
                    "statusCode": "JourneyEnd"
                },
                {
                    "message": {
                        "buttonText": "Continue",
                        "footerMsg": "",
                        "subHeaderMsg2": "you can continue your journey from here.",
                        "subHeaderMsg1": "currently we are unable to process your request",
                        "headerMsg": "Dear {name},<br /> Looks like you had applied earlier",
                        "middleMsg": ""
                    },
                    "statusCode": "SD101"
                },
                {
                    "message": {
                        "buttonText": "Provide information",
                        "footerMsg": "",
                        "subHeaderMsg2": "We request you to provide additional information to process your application.",
                        "subHeaderMsg1": "Your application number is {applicationnumber}",
                        "headerMsg": "Dear {name},<br />thank you for your request",
                        "middleMsg": ""
                    },
                    "statusCode": "JourneyEndDataCapture"
                }
            ],
            "errorItem": "Journey End"
        },
        {
            "error_msg": [
                {
                    "message": {
                        "buttonText": "Okay",
                        "footerMsg": "You can also track your application status using the application number on www.sbicard.com",
                        "subHeaderMsg2": "Your application number is {applicationnumber}",
                        "subHeaderMsg1": "Currently we are unable to process your request",
                        "headerMsg": "Hello {name}, thank you for request!",
                        "middleMsg": "We are now validating your application and will update you through SMS, post approval"
                    },
                    "statusCode": 101
                },
                {
                    "message": {
                        "buttonText": "Okay",
                        "footerMsg": "You can also track your application status using the application number on www.sbicard.com",
                        "subHeaderMsg2": "Your application number is {applicationnumber}",
                        "subHeaderMsg1": "Currently we are unable to process your request",
                        "headerMsg": "Hello {name}, thank you for request!",
                        "middleMsg": "We are now validating your application and will update you through SMS, post approval"
                    },
                    "statusCode": 102
                },
                {
                    "message": {
                        "buttonText": "Okay",
                        "footerMsg": "You can also track your application status using the application number on www.sbicard.com",
                        "subHeaderMsg2": "\"\"",
                        "subHeaderMsg1": "Your application for #cardName# card has been submitted successfully and Your application number is {applicationnumber}",
                        "headerMsg": "Hello {name}, thank you for your PAN card",
                        "middleMsg": "Unfortunately, we are unable to issue an instant card. We are now validating your application and will update you in 3-5 days through SMS, post approval"
                    },
                    "statusCode": "008"
                }
            ],
            "errorItem": "WIP"
        }
    ],
    "verbiageContainer": [
        {
            "actionName": "Send OTP",
            "errorContainer": {
                "errorCode": 999,
                "errorMsg": "Error sending OTP"
            }
        },
        {
            "actionName": "ValidateOTP",
            "errorContainer": [
                {
                    "errorCode": 101,
                    "errorMsg": "Please click on resend otp to get a new otp"
                },
                {
                    "errorCode": 102,
                    "errorMsg": "You have reached the maximum limit for OTP validation"
                },
                {
                    "errorCode": 104,
                    "errorMsg": "Please enter a valid OTP"
                },
                {
                    "errorCode": 999,
                    "errorMsg": "Otp validation failed"
                }
            ]
        },
        {
            "actionName": "UpdateCity",
            "errorContainer": [
                {
                    "errorCode": 999,
                    "errorMsg": "Error while saving city"
                },
                {
                    "errorCode": 900,
                    "errorMsg": "Error while saving city"
                }
            ]
        },
        {
            "actionName": "ValidatePan",
            "errorContainer": [
                {
                    "errorCode": 100,
                    "errorMsg": "Please enter a Valid Pan Number"
                },
                {
                    "errorCode": 900,
                    "errorMsg": "Pan authentication failed"
                },
                {
                    "errorCode": 901,
                    "errorMsg": "Pan authentication failed"
                },
                {
                    "errorCode": 999,
                    "errorMsg": "Pan authentication failed"
                }
            ]
        },
        {
            "actionName": "updateEmailName",
            "errorContainer": [
                {
                    "errorCode": 999,
                    "errorMsg": "Error Saving details"
                },
                {
                    "errorCode": 900,
                    "errorMsg": "Error Saving details"
                }
            ]
        },
        {
            "actionName": "updateProfessional",
            "errorContainer": [
                {
                    "errorCode": 999,
                    "errorMsg": "Error Saving details"
                },
                {
                    "errorCode": 900,
                    "errorMsg": "Error Saving details"
                }
            ]
        },
        {
            "actionName": "updateOfficeAdd",
            "errorContainer": [
                {
                    "errorCode": 999,
                    "errorMsg": "Error Saving details"
                },
                {
                    "errorCode": 900,
                    "errorMsg": "Error Saving details"
                }
            ]
        }
    ]
}

export default verbiageContent;